<template>
    <div>
        <b-sidebar
            v-if="isSidebarOpen"
            v-model="isSidebarOpen"
            id="sidebar-right"
            :title="modalTitle()"
            right
            backdrop
            shadow
            width="109em"
            backdrop-variant="dark"
            ref="editItem"
            no-close-on-backdrop
            @change="closeSidePanelCallback()"
        >
            <div class="d-block">
                <form @submit.prevent="createOrUpdateItem()" class="mb-4">
                    <h5 class="mb-3">Данные по запросу</h5>
                    <div class="form-row">
                        <div class="form-group col-md-2">
                            <b-form-group label="Тип запроса">
                                <b-form-radio-group
                                    v-model="editedItem.reference_type_id"
                                    :options="typeOfRequestOptions"
                                    name="radio-type_of_request"
                                ></b-form-radio-group>
                            </b-form-group>
                        </div>
                        <div class="form-group col-md-9">
                            <label>Опишите ваш запрос</label>
                            <b-form-textarea
                                id="textarea-comment"
                                placeholder="Например, необходимо выставить счет..."
                                rows="8"
                                v-model="editedItem.comment"
                            ></b-form-textarea>
                        </div>
                    </div>

                    <div class="text-right mt-3">
                        <button type="submit" class="btn btn-primary">Сохранить<i class="fas fa-spinner fa-spin ml-1" v-if="savingProcess"></i></button>
                    </div>
                </form>
            </div>
        </b-sidebar>
    </div>
</template>

<script>
    import {API_FINANCE_REQUESTS} from "../../constants"
    import tsoftChangeHistory from '../../components/logs/ChangeHistory.vue'
    import tsoftCreateFinanceRequest from './CreateFinanceRequest'

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        changeCommasOnDots,
    } from '../../mixins'

    const initialEditedItem = () => ({
        id: '',
        creator_user_id: '',
        for_user_id: '',
        finance_id: '',
        order_id: '',
        order_service_id: '',
        company_id: '',
        comment: '',
        reference_type_id: '',
        reference_status_id: '',
        type_of_request: '',            // auto field with type of request name
        operation_generation: '',       // auto filed with operation text generation by incoming parameters
        status: '',                     // auto field with status of request name
    })

    export default {
        components: {
            'tsoft-change-history': tsoftChangeHistory,
            'tsoft-create-finance-request': tsoftCreateFinanceRequest
        },
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            changeCommasOnDots,
        ],
        props: {
            order_id: { type: Number || String, required: true },
            company_id: { type: Number || String, required: true },
            finance_id: { type: Number || String, required: true },
            order_service_id: { type: Number || String, required: false },
        },
        data() {
            return {
                model_name: ['App\\Models\\FinanceRequest'],
                changeLoad: false,
                tableApiUrl: API_FINANCE_REQUESTS,
                typeOfRequestOptions: [],
                isSidebarOpen: true
            }
        },
        watch: {
            "editedItem.reference_type_id"(val) {
                if (val) {
                    this.editedItem.comment = this.typeOfRequestOptions.find(option => option.value === val).defaultText
                }
            }
        },
        mounted() {
            this.setTypeOfRequestOptions();
            this.editedItem = initialEditedItem();
            this.editedItem.order_id = this.order_id;
            this.editedItem.finance_id = this.finance_id;
            this.editedItem.company_id = this.company_id;
            if (this.order_service_id) {
                this.editedItem.order_service_id = this.order_service_id;
            }
        },
        methods: {
            setTypeOfRequestOptions() {
                let operation316DefText = 'Оплатите, пожалуйста, счет ';
                if (this.order_id) {
                    operation316DefText += `по заказу #${this.order_id}`;
                }
                if (this.order_id && this.finance_id) {
                    operation316DefText += ', ';
                }
                if (this.finance_id) {
                    operation316DefText += `по операции #${this.finance_id}`
                }

                this.typeOfRequestOptions = [
                    { value: 315, text: 'Счет на предоплату', defaultText: `Предоставьте, пожалуйста, счет на предоплату` },
                    { value: 317, text: 'Комплект документов', defaultText: `Предоставьте, пожалуйста, комплект документов` },
                    { value: 316, text: 'Оплатить счет', defaultText: operation316DefText },
                    { value: 318, text: 'Другое', defaultText: '' },
                ]
            },
            closeSidePanelCallback() {
                this.$emit("close")
            },
            modalTitle() {
                let title = 'Добавление нового запроса'
                if (this.editIndex > -1) {
                    title = 'Редактирование запроса #' + this.editedItem.id
                }

                return title
            },
        }
    }
</script>
